<dsy-card render-level="outer" has-border="true">
  <div class="filters">
    <div class="filters__fields">
      <div class="filters__field">
        <dr-ops-stream-ui-searchable-dropdown
          [label]="'Activity Type'"
          [entries]="activityFilterEntriesSignal()"
          [handleChange]="onActivityChange"
        ></dr-ops-stream-ui-searchable-dropdown>
      </div>
      <div class="filters__field">
        <dr-ops-stream-ui-searchable-dropdown
          [label]="'Program'"
          [entries]="programFilterEntriesSignal()"
          [handleChange]="onProgramChange"
        ></dr-ops-stream-ui-searchable-dropdown>
      </div>
      <div class="filters__field">
        <dr-ops-stream-ui-searchable-dropdown
          [label]="'Created by'"
          [entries]="createdByFilterEntriesSignal()"
          [handleChange]="onCreatedByChange"
        ></dr-ops-stream-ui-searchable-dropdown>
      </div>
      <div class="filters__field">
        <dsy-input #dueDateInput type="date" label="Due Date" placeholder="Select a date" [handleChange]="onDueDateChange"></dsy-input>
      </div>
      <div class="filters__field">
        <dsy-input-dropdown
          [label]="'Status'"
          [placeholder]="'Select an option...'"
          [exclusiveSelection]="true"
          [closesOnSelection]="true"
          [entries]="tagFilterEntriesSignal()"
          [handleChange]="onTagChange"
        >
        </dsy-input-dropdown>
      </div>
    </div>
    <div class="filters__actions">
      <dsy-button class="filters__reset" variant="link" color="neutral" (click)="onReset()" [disabled]="applyButtonDisabledSignal()"> Reset all filters </dsy-button>
      <dsy-divider class="filters__divider" divider-orientation="vertical" divider-color="light-grey"></dsy-divider>
      <dsy-button class="filters__apply" variant="primary" fill (click)="onApply()" [disabled]="applyButtonDisabledSignal()"> Apply</dsy-button>
    </div>
  </div>
</dsy-card>
